import CrmAutomationsAPI from '../../api/crmAutomations';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getAutomations: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
};

export const mutations = {
  SET_CRM_AUTOMATION_UI_FLAG($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
  SET_CRM_AUTOMATIONS($state, records) {
    $state.records = records;
  },
  UPSERT_CRM_AUTOMATION($state, record) {
    const index = $state.records.findIndex(item => item.id === record.id);
    if (index > -1) {
      $state.records.splice(index, 1, record);
    } else {
      $state.records.push(record);
    }
  },
  DELETE_CRM_AUTOMATION($state, id) {
    $state.records = $state.records.filter(item => item.id !== id);
  },
};

export const actions = {
  async fetch({ commit }) {
    commit('SET_CRM_AUTOMATION_UI_FLAG', { isFetching: true });
    try {
      const { data } = await CrmAutomationsAPI.get();
      commit('SET_CRM_AUTOMATIONS', data.payload);
    } finally {
      commit('SET_CRM_AUTOMATION_UI_FLAG', { isFetching: false });
    }
  },
  async create({ commit }, automation) {
    commit('SET_CRM_AUTOMATION_UI_FLAG', { isCreating: true });
    try {
      const { data } = await CrmAutomationsAPI.create({ automation });
      commit('UPSERT_CRM_AUTOMATION', data);
      return data;
    } finally {
      commit('SET_CRM_AUTOMATION_UI_FLAG', { isCreating: false });
    }
  },
  async update({ commit }, { id, ...automation }) {
    commit('SET_CRM_AUTOMATION_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await CrmAutomationsAPI.update(id, { automation });
      commit('UPSERT_CRM_AUTOMATION', data);
      return data;
    } finally {
      commit('SET_CRM_AUTOMATION_UI_FLAG', { isUpdating: false });
    }
  },
  async toggle({ commit }, id) {
    const { data } = await CrmAutomationsAPI.toggle(id);
    commit('UPSERT_CRM_AUTOMATION', data);
  },
  async delete({ commit }, id) {
    commit('SET_CRM_AUTOMATION_UI_FLAG', { isDeleting: true });
    try {
      await CrmAutomationsAPI.delete(id);
      commit('DELETE_CRM_AUTOMATION', id);
    } finally {
      commit('SET_CRM_AUTOMATION_UI_FLAG', { isDeleting: false });
    }
  },
};

export default { namespaced: true, state, getters, actions, mutations };
